import React from "react";
import PolicyLayout from "./policyLayout";
import Seo from "components/Seo";

const Privacy = () => {
    return (
        <React.Fragment>
            <Seo type="" pageTitle="개인정보처리방침" />
            <PolicyLayout>
                <div className="bg-[#f4f4f4] flex flex-col items-center justify-center pb-16 pt-5 responsive1200:pt-0 responsive1200:px-[4%]">
                    <p className="py-[35px] text-[#333] text-[28px] font-[600] responsive1200:py-[30px] responsive1200:text-[24px]">
                        개인정보처리방침
                    </p>
                    <div className="bg-white px-[4%] py-[50px] max-w-[1200px] mx-auto">
                        <div className="border border-[#dddddd] p-[15px] text-[#666666] text-[14px]">
                            <p>
                                제1조[목적]
                                <br />
                                회사는 정보통신망이용촉진및정보보호등에관한법률(이하 "정통망법"이라 함)등 모든 관련법규를 준수하며 회원님의
                                개인정보가 보호받을 수 있도록 최선을 다하고 있습니다. 회사는 개인정보취급방침의 공개를 통하여 회원 여러분의
                                개인정보가 어떠한 목적과 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지를
                                알려드립니다. 본 개인정보취급방침은 관련법령의 개정이나 당사 내부방침에 의해 변경될 수 있으며 회원 가입 시나
                                사이트 이용 시에 수시로 확인하여 주시기 바랍니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제2조[용어의정의] <br />본 개인정보취급방침에서의 사용되는 용어의 정의는 다음과 같다.
                            </p>
                            <p>
                                ① 퀵서비스라 함은 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 또는
                                용역을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버 영업을 운영하는 사업자들의 의미로도
                                사용합니다.
                                <br />
                                ② 회사에 회원으로 등록한 이용자가 다양한 정보와 서비스를 제공받을 수 있도록 회사가 제작, 운영하는 인터넷
                                웹사이트를 의미합니다. <br />③ 회원이란 회사에게 개인정보제공의 동의와 함께 회원등록을 하고 ID를 부여 받은
                                회원 또는 그 회원전체를 의미하며, 회원 등록 시 부여 받은 ID로 당사의 모든 서비스를 이용 할 수 있으며, 이때의
                                가입은 관계사일 경우, 약관 동의 절차만으로도 이용이 가능함을 의미합니다. <br />④ "이용자"라 함은 회사에
                                접속하여 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다. <br />⑤ "회원"이라 함은
                                "회사"에 개인정보를 제공하여 회원등록을 한 자로서, "회사 회원"에 가입한 자 를 의미합니다. <br />⑥
                                "비회원"이라 함은 회원에 가입하지 않고 회사가 제공하는 서비스를 이용하는 자를 말합니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                1. 개인정보의 수집항목 및 이용목적 <br />
                                2. 개인정보 수집에 대한 동의 <br />
                                3. 수집하는 개인정보의 이용 및 보유기간 <br />
                                4. 개인정보의 열람, 갱신, 수정 또는 삭제 <br />
                                5. 동의철회 및 파기 <br />
                                6. 제3자에 대한 제공 및 위탁처리업체 <br />
                                7. 개인정보보호를 위해 회원들이 알아야 할 사항 <br />
                                8. 비회원 고객의 개인정보수집 및 보호 <br />
                                9. 아동의 개인정보보호 <br />
                                10. 쿠키의 운영 및 활용 <br />
                                11. 링크사이트 <br />
                                12. 개인정보 보호를 위한 기술적, 관리적 대책 <br />
                                13. 게시물에 포함된 개인정보 <br />
                                14. 개인정보관련 의견수렴 및 불만처리에 관한 사항 <br />
                                15. 개인정보 관리책임자 및 담당자의 소속, 성명 및 연락처 <br />
                                16. 방침변경등에 대한 고지
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제3조[개인정보의 수집항목 및 이용목적] <br />① 개인정보란 생존하는 개인에 관한 정보로서 당해 정보에 포함되어
                                있는 성명 등의 사항에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수
                                없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다. <br />② 회사는 고객이
                                회원가입을 할 때 서비스 제공을 위해 필요한 필수적인 최소한의 개인정보를 받고 있습니다. 회사가 고객의
                                개인정보를 수집하는 목적은 당 사이트를 통하여 고객에게 최적의 서비스를 제공해 드리기 위한 것이며 고객이
                                제공한 개인정보를 바탕으로 고객에게 보다 더 유용한 정보를 선택적으로 제공하기 위한 것입니다. <br />③ 회사는
                                고객의 사전 동의 없이는 고객의 개인정보를 사전에 밝힌 목적 이외로 이용하거나 제3자에게 공개하지 않습니다.{" "}
                                <br />④ 회사는 관련 법령에 의하거나 기타 아래의 항목을 다음과 같은 목적을 위하여 개인정보를 수집하고
                                있습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                가. 필수항목 <br />- 성명, 휴대전화번호, 전자메일주소, 아이디, 비밀번호: 이용자 본인 식별을 위한 목적 등.{" "}
                                <br />
                                - 전자메일주소, 연락처: 회원정보관리를 위한 연락 및 안내 목적 <br />- 법정대리인의
                                이름/전자메일/휴대폰번호/통신사 정보: 만 14세 미만 아동에 대한 법정대리인 동의 확인을 위한 목적, 채권 추심
                                등
                                <br />- IP Address, 방문일시, 서비스 이용기록(자동으로 생성되는 개인정보): 부정이용방지, 비인가 사용 방지,
                                분쟁조정 해결을 위한 기록보존 등
                            </p>
                            <p>
                                <br />
                                나. 선택항목 <br />- 아이핀정보, 연계정보(CI), 중복가입확인정보(DI),: 상품주문 및 결제를 위한 본인 식별 목적
                                <br />- 기본배송지, 연락처, 수취인의 성명/ 전화번호/휴대폰 번호/배송주소: 고객이 주문하신 상품 및 경품
                                배송을 위한 목적, 채권추심 등 <br />- 연락처, SMS수신여부, 전자메일, 메일수신여부, DM수신 여부,
                                유선안내(TM)수신여부: 계약이행에 대한 연락 및 안내 등의 고지를 위한 목적, 서비스 판매 정보제공 홍보
                                가입권유활동 (할인쿠폰, 마일리지 판촉광고 포함) 안내 등의 고지를 위한 목적 등 <br />- 은행계좌번호,
                                입금(예금)자명, 은행명, 휴대폰번호: 대금결제서비스 제공용 <br />- 생년월일, 닉네임: 고객님의 편의를 위한
                                맞춤광고 및 서비스 제공, 기념일 행사쿠폰 발송 및 서비스 품질 향상을 위한 제휴서비스를 제공하기 위한 목적{" "}
                                <br />- 주민등록번호: 전자상거래 등에서의 소비자보호에 관한 법률 제6조 '거래기록 보존' 등 <br />-
                                개인통관고유부호 : 해외 직배송 상품 통관업무처리 목적
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />⑤ 회사는 고객님의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및
                                본적지, 정치적 성향 및 범죄기록, 건강상태 등)는 수집하지 않습니다. <br />⑥ 수집방법 : 홈페이지 (회원가입)
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제4조[개인정보 수집에 대한 동의] <br />
                                회사는 회원님께서 회사의 개인정보활용동의서 및 이용약관의 내용에 대해 "동의한다" 버튼 또는 "동의하지 않는다"
                                버튼을 클릭(Click)할 수 있는 절차를 마련하여, "동의한다"버튼을 클릭할 경우에, 입력하신 개인정보들이 당사의
                                고객DB에 저장되어 "동의" 버튼 위에 명시된 이용목적대로 이용되는 것을 동의한 것으로 간주하게 됩니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제5조[수집하는 개인정보의 이용 및 보유기간] <br />① 정보통신망 이용촉진 및 정보보호 등에 관한 법률에 따라
                                동법 시행일인 2012. 8.18일부터 2년내에 보유하고 있는 주민등록번호는 파기하고, 3년간 이용실적이 없는 회원에
                                있어서도 동법에 규정하는 방식에 근거한 파기 또는 관리를 다합니다. <br />② 회원님의 개인정보는 다음과 같이
                                개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기됩니다. 다만, 전자상거래등에서의소비자보호에관한법률
                                등 관련법령에 의해 보존할 의무가 있는 경우에는 법령에서 정한 기간동안 보존하며, 이 경우 회사는 보관하는
                                정보를 그 보관목적으로만 이용합니다. 또한 고객의 안전과 피해방지를 위해 회원 탈퇴 후 회원 최소한의 정보는
                                명의도용 등 불, 편법 행위의 방지 및 대응의 목적으로 60일간 별도 보관합니다. <br />- 회원가입정보의 경우,
                                회원가입을 탈퇴하거나 회원에서 제명된 경우에는 사전에 보유목적, 기간 및 보유하는 개인정보 항목을 명시하여
                                동의를 구합니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                가. 계약 또는 청약철회 등에 관한 기록: 5년 <br />
                                나. 대금결제 및 재화 등의 공급에 관한 기록: 5년 <br />
                                다. 소비자의 불만 또는 분쟁처리에 관한 기록: 5년 <br />
                                라. 표시, 광고에 관한 기록: 6개월 <br />
                                마. 사이트 접속에 관한 기록 : 12개월
                            </p>
                            <p>
                                <br />③ 회원님의 동의를 받아 보유하고 있는 거래정보 등을 회원님께서 열람을 요구하는 경우에는 소정의
                                본인확인절차를 거친 후 지체 없이 열람, 확인할 수 있도록 조치합니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제6조[개인정보의 열람, 갱신, 수정 또는 삭제] <br />① 회원님께서는 언제든지 등록되어 있는 회원님의 개인정보를
                                열람하거나 수정하실 수 있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 회원사 홈페이지에서 로그인 후
                                "회원정보 /수정"항목을 클릭하여 직접 열람 또는 정정하거나, 개인정보관리책임자 및 민원담당자에게 서면, 전화
                                또는 E-mail로 연락하시면 지체 없이 조치하겠습니다. <br />② 회원님께서 개인정보의 오류에 대한 정정을 요청한
                                경우, 정정을 완료하기 전까지 당해 개인 정보를 이용 또는 제공하지 않습니다. <br />③ 잘못된 개인정보를
                                제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정하도록 조치하겠습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제7조[동의철회 및 파기] <br />
                                회원가입 등을 통한 개인정보의 수집, 이용, 제공에 대하여 회원은 가입 시 동의한 내용에 대해서 언제든지 철회할
                                수 있습니다. 동의 철회는 당사의 사이트에 로그인 후, "회원탈퇴하기"에서 언제든지 철회할 수 있으며, 개인정보
                                민원담당자에게 서면, 전화, e-mail 등으로 연락하시면 신속하게 개인정보의 삭제 등 필요한 조치를 합니다. <br />
                                단, 회원ID에 대해서는 서비스 이용의 혼선 방지, 법령에서 규정하는 회원거래정보의 보존기간 동안의 보관의무의
                                이행, 기타 안정적인 서비스 제공을 위하여 필요한 정보이므로, 탈퇴후 동일 ID로의 재가입은 허용되지 않습니다.
                            </p>
                            <p>
                                이미 제공된 회원정보를 철회 하는 데는 일정 시간이 소요되며 소요되는 시간 동안 마케팅에 활용되지 않도록
                                하겠습니다. 회사는 회원님의 소중한 정보를 보호하기 위하여 신속하게 처리되도록 최선의 노력을 다하겠습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제8조[제3자에 대한 제공 및 위탁처리업체] <br />① 회사는 고객의 동의가 있거나 법률의 규정에 의한 경우를
                                제외하고는 어떠한 경우에도 "1. 개인정보의 수집항목 및 이용목적"에서 고지한 범위를 넘어서 고객의 개인정보를
                                이용하거나 타인 또는 타기업, 기관에 제공하지 않습니다. <br />② 회사가 제공하는 서비스를 통하여 회원간의
                                거래관계가 이루어진 경우, 배송 등 거래이행을 위하여 관련 정보는 필요한 범위내에서 회원이 동의한 경우 아래와
                                같이 거래 당사자에게 제공합니다. <br />③ 회사는 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리금지,
                                기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등
                                문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. <br />④ 회사가 고객의
                                개인정보를 제3자에게 제공하는 경우 사전에 고객에게 고객의 개인정보를 제공받는자, 개인정보를 제공받는 자의
                                개인정보 이용목적, 제공하는 개인정보의 항목, 개인정보를 제공받는 자의 개인정보 보유 및 이용기간에 대해
                                동의를 구하는 절차를 거치거나 회원 가입시 별도로 동의를 구하는 절차를 거치게 됩니다. 고객이 동의하지 않는
                                경우에는 개인정보를 제공하거나 공유하지 않습니다. 고객이 개인정보의 제공에 동의하더라도 언제든지 그 동의를
                                철회할 수 있습니다.
                                <br />⑤ 다음의 경우에는 예외적으로 고객의 동의 없이 개인정보를 제공할 수 있습니다.
                            </p>
                            <p>
                                가. 형사소송법, 금융실명거래및비밀보장에관한법률, 신용정보의이용및보호에관한법률, 전기통신기본법,
                                전기통신사업법, 전파법, 지방세법, 소비자보호법, 한국은행법, 등 관계법령에 특별한 규정이 있는 경우 <br />
                                나. 통계작성, 학술연구나 시장조사를 위하여 특정 개인을 식별할 수 없는 형태로 제공하는 경우 <br />
                                다. 그러나 예외 사항에서도 관계법령에 의하거나 수사기관의 요청에 의해 정보를 제공한 경우에는 본래의 수집목적
                                및 이용목적에 반하여 무분별하게 정보가 제공되지 않도록 최대한 노력하겠습니다.
                            </p>
                            <p>
                                ⑥ 회사는 보다 나은 서비스 제공과 고객 편의 제공 등 업무수행을 원활하게 하기 위하여 회원이 동의한 경우 고객의
                                개인정보를 필요한 업무 범위 내에서 다음과 같이 타 업체에 수집, 보관, 처리 등을 위탁하여 처리하고 있습니다.
                            </p>
                            <p>
                                <br />
                                제9조[개인정보보호를 위해 회원들이 알아야 할 사항] <br />① 회원님의 개인정보를 최신의 상태로 정확하게
                                입력하여 불의의 사고를 예방해 주시기 바랍니다. 이용자가 입력한 부정확한 정보로 인해 발생하는 사고의 책임은
                                이용자 자신에게 있으며 타인 정보의 도용 등 허위정보를 입력할 경우 회원자격이 상실될 수 있습니다. <br />②
                                회원님은 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도 가지고
                                있습니다. 비밀번호를 포함한 회원님의 개인정보가 유출되지 않도록 주의하시고 게시물을 포함한 타인의 개인정보를
                                훼손하지 않도록 유의해 주십시오. 만약 이 같은 책임을 다하지 못하고 타인의 정보 및 존엄성을 훼손할 시에는
                                『정보통신망이용촉진 및 정보보호등에 관한법률』등에 의해 처벌받을 수 있습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />* 타인의 주민번호를 도용하여 온라인 회원가입을 하는 등 다른 사람의 주민등록번호를 부정하게 사용자는
                                3년 이하의 징역 또는 1천만 원 이하의 벌금이 부과될 수 있습니다. <br />※ 참조: 주민등록법 제37조(벌칙)(시행일
                                2011. 8. 31)
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제10조[비회원 고객의 개인정보수집 및 보호] <br />
                                회사에서는 회원뿐만 아니라 비회원 또한 물품 및 서비스 상품의 구매를 하실 수 있습니다. 회사는 비회원 주문의
                                경우 배송 및 대금 결제, 상품 배송에 반드시 필요한 개인정보 만을 고객에게 요청하고 있습니다. 회사에서
                                비회원으로 구매를 하신 경우 비회원 고객께서 입력하신 지불인 정보 및 수령인 정보는 대금 결제 및 상품 배송에
                                관련한 용도 외에는 다른 어떠한 용도로도 사용되지 않습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제11조[아동의 개인정보보호] <br />① 당사는 온라인 환경에서 만14세 미만 아동의 개인정보를 보호하는 것 역시
                                중요한 일이라고 생각하고 있습니다. 만 14세 미만인 개인정보는 법정대리인의 동의없이는 수집하지 않음을 원칙{" "}
                                <br />② 만 14세 미만 및 법정대리인의 개인정보보호를 위한 열람, 수정, 동의 철회 등의 권리와 행사방법은 회원에
                                대한 규정을 준용합니다.
                            </p>
                            <p>
                                제12조[쿠키의 운영 및 활용] <br />① 회사는 다른 많은 웹사이트와 마찬가지로 쿠키를 운용합니다.
                                '쿠키(cookie)'는 회원님에 대한 정보를 저장하고 수시로 찾아내는 역할을 합니다. 그리고, 웹사이트가 회원님의
                                컴퓨터 브라우저(넷스케이프, 인터넷 익스플로러 등)로 전송하는 4KB 미만의 텍스트로 이뤄진 소량의 정보입니다.{" "}
                                <br />② 회원께서 회사의 웹사이트에 접속을 하시면, 회사의 컴퓨터는 회원님의 브라우저에 있는 쿠키의 내용을
                                읽고, 회원의 추가정보를 회원님의 컴퓨터에서 찾아 접속에 따른 성명 등의 추가 입력 없이 서비스를 제공할 수
                                있습니다. <br />③ 회원께서는 쿠키에 대한 선택권이 있으며, 다음과 같은 방법으로 쿠키의 전부 또는 일부를
                                받아들여 웹 브라우저 상단의 "도구 &gt; 인터넷옵션&gt;개인정보&gt;개인정보 설정"에서
                                "모든쿠키허용-낮음-보통-보통 높음-높음-모든쿠키차단"을 할 수 있는 선택권을 가질 수 있습니다. 그러나,
                                회원님께서 쿠키에 대한 설치를 거부하거나 삭제로 설정한 경우에는 해당 웹 페이지에 일정부분에 대해서 접근할
                                때마다 회원님의 아이디(ID)나 비밀번호(password)를 다시 입력하셔야 합니다. <br />④ 회사는 이용자의 편의를
                                위하여 쿠키를 운영하며. 회사가 쿠키를 통해 수집하는 정보는 회원 ID에 한하며, 그 외의 다른 정보는 수집하지
                                않습니다. 수집된 회원의 ID는 타겟(Target) 마케팅 등의 목적을 위해 사용될 수 있습니다. 쿠키는 브라우저의 종료
                                시나 로그아웃 시 만료됩니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제13조[링크사이트] <br />
                                회사는 회원님께 다른 회사 및 관계사의 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다. 이 경우 회사는
                                외부사이트 및 자료에 대한 아무런 통제권이 없으므로 그것으로부터 제공받는 서비스나 자료의 유용성에 대해
                                책임질 수 없으며 보증할 수 없습니다. 회사가 포함하고 있는 링크를 클릭(click)하여 타 사이트(site)의 페이지로
                                옮겨갈 경우 해당 사이트의 개인정보취급방침은 회사와 무관하므로 새로 방문한 사이트의 방침을 살펴 보시기
                                바랍니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제14조[개인정보 보호를 위한 기술적, 관리적 대책] <br />① 기술적 대책 <br />
                                회사는 회원님의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성
                                확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
                            </p>
                            <p>
                                가. 회원님의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를 암호화하거나 파일 잠금기능(Lock)을
                                사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다. <br />
                                나. 회사는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다.
                                백신프로그램은 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써
                                개인정보가 침해되는 것을 방지하고 있습니다. <br />
                                다. 회사는 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를
                                채택하고 있습니다. <br />
                                라. 해킹 등 외부침입에 대비하여 침입차단시스템 및 취약점 분석시스템 등을 이용하여 보안에 만전을 기하고
                                있습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />② 관리적 대책 <br />
                                회사는 고객님의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있습니다. 그 최소한의 인원에 해당하는
                                자는 다음과 같습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                가. 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자, 개인정보관리책임자 및 담당자 등 개인정보관리업무를
                                수행하는 자, 기타 업무상 개인정보의 취급이 불가피한 자. <br />
                                나. 개인정보를 취급하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보 보호 의무 등에 관해 정기적인 사내
                                교육을 실시하고 있습니다. <br />
                                다. 입사 시 개인정보 관련 취급자의 보안서약서를 통하여 사람에 의한 정보유출을 사전에 방지하고
                                개인정보취급방침에 대한 이행사항 및 직원의 준수여부를 감사하기 위한 내부절차를 마련하고 있습니다. <br />
                                라. 개인정보 관련 취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후
                                개인정보 사고에 대한 책임을 명확화하고 있습니다. <br />
                                마. 개인정보와 일반 데이터를 혼합하여 보관하지 않고 별도로 분리하여 보관하고 있습니다. <br />
                                바. 전산실 및 자료 보관실 등을 특별 보호구역으로 설정하여 출입을 통제하고 있습니다. <br />
                                사. 회사는 이용자 본인의 부주의 또는 인터넷상의 문제로 인해 발생한 개인정보 유출문제에 대해 고의, 과실이
                                없을 경우 책임을 지지 아니합니다. 회원 개개인이 본인의 개인정보를 보호하기 위해서 자신의 ID 와 비밀번호를
                                적절하게 관리하고 여기에 대한 책임을 져야 합니다. <br />
                                아. 그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 변조, 훼손이 유발될 경우
                                회사는 즉각 회원님께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다. <br />
                                자. 회사는 고객의 개인정보를 보호하여 개인정보 유출로 인한 피해가 발생하지 않도록 하기 위하여 다음과 같은
                                방법을 통하여 개인정보를 파기합니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                1) 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. <br />
                                2) 전자적 파일 형태로 저장된 개인 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제15조[게시물에 포함된 개인정보] <br />
                                당사는 회원님의 게시물을 소중하게 생각하며 변조, 훼손, 삭제되지 않도록 최선을 다하여 보호합니다. 그러나
                                다음의 경우에는 명시적 또는 개별적인 경고 후 삭제 조치할 수 있습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />- 스팸(spam)성 게시물(예; 행운의 편지, 돈 버는 메일 등) <br />- 타인을 비방할 목적으로 허위사실을
                                유포하여 타인의 명예를 훼손하는 글 <br />- 동의 없는 타인의 개인정보 공개 <br />- 제 3자의 저작권 등 권리를
                                침해하는 내용
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                당사는 바람직한 게시판 문화를 활성화하고 개인정보를 보호하기 위하여 동의 없이 타인의 개인정보를 게시한 경우
                                특정부분을 삭제하거나 기호 등으로 수정하여 게시할 수 있습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제16조[개인정보관련 의견수렴 및 불만처리에 관한 사항] <br />① 회사는 개인정보와 관련된 회원의 의견수렴과
                                불만처리를 위하여 회원관리자를 지정해서 해당업무를 수행하도록 합니다. <br />② 회사는 회원님의 의견을
                                소중하게 생각하며, 회원님은 의문사항으로부터 언제나 성실한 답변을 받을 권리가 있습니다. <br />③ 회사는
                                회원님과의 원활환 의사소통을 위해 민원처리센터를 운영하고 있으며 연락처는 다음과 같습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                [민원처리 주업무] <br />
                                전화상담은 평일 09:00 ~ 18:00까지 가능합니다. <br />
                                전자우편이나 팩스 및 우편을 이용한 상담은 접수 후 24시간 내에 성실하게 답변 드리겠습니다. 다만, 근무시간
                                이후 또는 주말 및 공휴일에는 익일 처리하는 것을 원칙으로 합니다. <br />
                                기타 개인정보에 관한 상담이 필요한 경우에는 개인정보침해신고센터, 정보보호마크 인증위원회, 대검찰청
                                인터넷범죄수사센터, 경찰청 사이버범죄수사대 등으로 문의하실 수 있습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />* 개인정보침해신고센터 <br />
                                - 전화 : 02) 118 <br />- URL : <a href="http:www.118.or.kr">http://www.118.or.kr</a>
                            </p>
                            <p>
                                <br />* 경찰청 사이버테러대응센터 <br />
                                - 전화 : 02-393-9112 <br />- URL : <a href="http:www.ctrc.go.kr">http://www.ctrc.go.kr/</a>
                            </p>
                            <p>
                                <br />* 대검찰청 사이버범죄수사단 <br />- URL :
                                <a href="http://www.spo.go.kr/minwon/center/report/minwon24.jsp">
                                    http://www.spo.go.kr/minwon/center/report/minwon24.jsp
                                </a>
                                <br />- e-mail : <a href="mailto:cybercid@spo.go.kr">cybercid@spo.go.kr</a>
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제17조[개인정보 관리책임자 및 담당자의 소속, 성명 및 연락처] <br />
                                회사는 회원님께서 양질의 정보를 안전하게 이용하실 수 있도록 최선을 다하고 있습니다. 개인정보를 보호하는데
                                있어 회원님께 고지한 사항들에 반하는 사고가 발생할 시에 개인정보관리책임자가 모든 책임을 집니다. 그러나
                                기술적인 보완조치를 했음에도 불구하고, 해킹 등 기본적인 네트워크상의 위험성에 의해 발생하는 예기치 못한
                                사고로 인한 정보의 훼손에 관해서는 책임이 없습니다. 회원님의 개인정보를 취급하는 책임자, 담당자들은 다음과
                                같으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해드리고 있습니다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                [개인정보 관리책임자] <br />
                                성　　명 : 김대일 <br />
                                직　　위 : 대표이사 <br />회 사 명 : (주)일신모닝택배 <br />
                                전화번호 : 1661-1116
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                [민원처리 대행센터] <br />- 전자우편 : <a href="mailto:ilshinair@ilshinair.com">ilshinair@ilshinair.com</a>
                                <br />- 전화번호 : 070-4818-1592 <br />- 팩스번호 : 031-971-4208 <br />- 주 소 : 서울 강서구 방화2동 647-14
                                일신빌딩 <br /> <br />
                            </p>
                        </div>
                    </div>
                </div>
            </PolicyLayout>
        </React.Fragment>
    );
};

export default Privacy;
